import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import moment from "moment";
import "./PackageForm.css"

const PackageTransfer = ({ packageId }) => {
  const initialFieldValues = {
    packageTransferId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    date: "",
    pickupTime: "",
    fromLocation: "",
    toLocation: "",
    vehicleDetails: "",
  };
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);


  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
        date: recordForEdit.date
          ? moment(recordForEdit.date).format("YYYY-MM-DD")
          : "",
      });
    }
  }, [recordForEdit]);
  const GetData = async () => {
    const res = await apiService.get(
      `${config.GETTRANSFERBYPACKAGEID}/${packageId}`
    );
    console.log(res);
    setLists(res.data);
  };

   const handleAddNewClick = () => {
    resetForm();
    setIsFormVisible(true);
  };
  
  const showEditDetails = (data) => {
    const formattedData = {
        ...data,
        date: moment(data.date).format('YYYY-MM-DD'),
    };
    setRecordForEdit(formattedData);
    setValues(formattedData);
    setIsFormVisible(true);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGETRANSFER, itemToDelete);
        await GetData();
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.date = values.date === "" ? false : true;
    temp.pickupTime = values.pickupTime === "" ? false : true;
    temp.fromLocation = values.fromLocation === "" ? false : true;
    temp.toLocation = values.toLocation === "" ? false : true;
    temp.vehicleDetails = values.vehicleDetails === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageTransferId: values.packageTransferId,
        packageId: packageId,
        date: values.date,
        pickupTime: values.pickupTime,
        fromLocation: values.fromLocation,
        toLocation: values.toLocation,
        vehicleDetails: values.vehicleDetails,
        userId: user?.id,
      };
      try {
        const isNew =
          formData.packageTransferId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGETRANSFER, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGETRANSFER, formData);
        }
        await GetData();
        resetForm();
        setIsFormVisible(false);
      } finally {
        setBtnLoading(false);
      }
    }
  };
  const handleCancel = () => {
    resetForm();
    setIsFormVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setBtnLoading(false);
    setRecordForEdit(null);
    setErrors({});
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);
 return (
    <div className="PackageTransfer-wrapper">
      <div className="card PackageTransfer-card">
        <div className="card-body">
          {/* --- HEADER --- */}
          <div className="PackageTransfer-header">
            <h4 className="header-title">Transfers & Transportation</h4>
            {!isFormVisible && (
              <button
                type="button"
                className="btn btn-primary PackageTransfer-btn-gradient"
                onClick={handleAddNewClick}
              >
                <i className="ri-add-line me-1"></i> Add Transfer
              </button>
            )}
          </div>

          {/* --- ADD/EDIT FORM (Conditional) --- */}
          {isFormVisible && (
            <div className="PackageTransfer-form-container">
              <h5 className="form-title">
                {values.packageTransferId === "00000000-0000-0000-0000-000000000000"
                  ? "Add Transfer Details"
                  : "Edit Transfer Details"}
              </h5>
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                   <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-road-map-line me-2"></i>From Location</label>
                      <input type="text" name="fromLocation" value={values.fromLocation} onChange={handleInputChange} className={"form-control" + applyErrorClass("fromLocation")} placeholder="e.g. Airport"/>
                      {errors.fromLocation === false && <div className="validationerror">Please enter a valid from location</div>}
                  </div>
                   <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-map-pin-line me-2"></i>To Location</label>
                      <input type="text" name="toLocation" value={values.toLocation} onChange={handleInputChange} className={"form-control" + applyErrorClass("toLocation")} placeholder="e.g. Hotel"/>
                      {errors.toLocation === false && <div className="validationerror">Please enter a valid to location</div>}
                  </div>
                  <div className="col-lg-2 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-calendar-event-line me-2"></i>Date</label>
                       <input type="date" name="date" value={values.date} onChange={handleInputChange} className={"form-control" + applyErrorClass("date")}/>
                       {errors.date === false && <div className="validationerror">Please select a valid date</div>}
                  </div>
                  <div className="col-lg-2 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-time-line me-2"></i>Pickup Time</label>
                       <input type="time" name="pickupTime" value={values.pickupTime} onChange={handleInputChange} className={"form-control" + applyErrorClass("pickupTime")}/>
                        {errors.pickupTime === false && <div className="validationerror">Please select a valid pickup time</div>}
                  </div>
                  <div className="col-lg-2 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-taxi-line me-2"></i>Vehicle</label>
                       <input type="text" name="vehicleDetails" value={values.vehicleDetails} onChange={handleInputChange} className={"form-control" + applyErrorClass("vehicleDetails")} placeholder="e.g. Sedan"/>
                        {errors.vehicleDetails === false && <div className="validationerror">Please enter valid vehicle details</div>}
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <button type="button" className="btn btn-light" onClick={handleCancel}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={btnLoading}>
                        {btnLoading ? "Saving..." : (values.packageTransferId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update")}
                    </button>
                </div>
              </form>
            </div>
          )}

          {/* --- TRANSFER LIST --- */}
          <div className="mt-4">
            {lists.length > 0 ? (
              <div className="PackageTransfer-list">
                {lists.map((v) => (
                  <div key={v.packageTransferId} className="PackageTransfer-list-item">
                    <div className="item-main-content">
                        <div className="item-icon">
                          <i className="ri-arrow-left-right-line"></i>
                        </div>
                        <div className="item-locations">
                            <span className="location-point">{v.fromLocation}</span>
                            <i className="ri-arrow-right-line location-arrow"></i>
                            <span className="location-point">{v.toLocation}</span>
                        </div>
                    </div>
                    <div className="item-details">
                        <div className="detail-item">
                            <i className="ri-calendar-2-line"></i> {moment(v.date).format("ddd, DD MMM YYYY")}
                        </div>
                         <div className="detail-item">
                            <i className="ri-time-line"></i> {v.pickupTime}
                        </div>
                         <div className="detail-item">
                            <i className="ri-taxi-wifi-line"></i> {v.vehicleDetails}
                        </div>
                    </div>
                    <div className="item-actions">
                        <button className="PackageTransfer-action-btn edit" onClick={() => showEditDetails(v)}><i className="ri-pencil-fill"/></button>
                        <button className="PackageTransfer-action-btn delete" onClick={() => handleOpenDeleteModal(v.packageTransferId)}><i className="ri-delete-bin-fill"/></button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
                <div className="PackageTransfer-empty-state">
                    <i className="ri-roadster-line empty-icon"></i>
                    <h5>No Transfers Added</h5>
                    <p>Click "Add Transfer" to include transportation details.</p>
                </div>
            )}
          </div>
        </div>
      </div>
      <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
    </div>
  );
};

export default PackageTransfer;